import axios, { AxiosInstance } from 'axios'
import { Configuration } from '../api'
import { SetAccessTokenRequestInterceptor, SetTimeZoneRequestInterceptor } from './interceptors'

const httpClient = axios.create()

export const setupInterceptors = () => {
  httpClient.interceptors.request.use(SetAccessTokenRequestInterceptor.onFulfilled)

  httpClient.interceptors.request.use(SetTimeZoneRequestInterceptor.onFulfilled)
}

setupInterceptors()

export const createApiClient = <T>(service: {
  new (configuration: Configuration, basePath: string, axios: AxiosInstance): T
}): T => {
  return new service(new Configuration(), window.location.origin, httpClient)
}

export default httpClient
